import Valentines from '../images/dividend/il_coupontheme_valentines.svg';
import VLeft from '../images/dividend/il-coupontheme-valentine-left.svg';
import VRight from '../images/dividend/il-coupontheme-valentine-right.svg';
import MLK from '../images/dividend/il_coupontheme_mlk.svg';
import MLKLeft from '../images/dividend/il-coupontheme-mlk-left.svg';
import MLKRight from '../images/dividend/il-coupontheme-mlk-right.svg';
import Memorial from '../images/dividend/il_coupontheme_memorial.svg';
import MLeft from '../images/dividend/il-coupontheme-memorial-left.svg';
import MRight from '../images/dividend/il-coupontheme-memorial-right.svg';
import Independence from '../images/dividend/il-coupontheme-independence.svg';
import ILeft from '../images/dividend/il-coupontheme-independence-left.svg';
import IRight from '../images/dividend/il-coupontheme-independence-right.svg';
import President from '../images/dividend/il-coupontheme-presidents.svg';
import PLeft from '../images/dividend/il-coupontheme-prez-left.svg';
import PRight from '../images/dividend/il-coupontheme-prez-right.svg';
import ThanksGiving from '../images/dividend/il-coupontheme-thanksgiving.svg';
import TLeft from '../images/dividend/il-coupontheme-thanksgiving-left.svg';
import TRight from '../images/dividend/il-coupontheme-thanksgiving-right.svg';
import Halloween from '../images/dividend/il-coupontheme-halloween.svg';
import HLeft from '../images/dividend/il-coupontheme-halloween-left.svg';
import HRight from '../images/dividend/il-coupontheme-halloween-right.svg';
import Easter from '../images/dividend/il-coupontheme-easter.svg';
import ELeft from '../images/dividend/il-coupontheme-easter-left.svg';
import ERight from '../images/dividend/il-coupontheme-easter-right.svg';
import Christmas from '../images/dividend/il-coupontheme-christmas.svg';
import CLeft from '../images/dividend/il-coupontheme-christmas-left.svg';
import CRight from '../images/dividend/il-coupontheme-christmas-right.svg';
import Labor from '../images/dividend/il-coupontheme-labor.svg';
import LLeft from '../images/dividend/il-coupontheme-labor-left.svg';
import LRight from '../images/dividend/il-coupontheme-labor-right.svg';
import JohnKeynes from '../images/dividend/img-johnmaynardkeynes.png'
import WarrenBuffet from '../images/dividend/img-warrenbuffett.png'
import JohnBogle from '../images/dividend/img-johnbogle.png'

class Constants {

  static InvestorTypes = [
    {
      entities: [
        {
          name: 'Individual',
          value: 'Individual'
        }
      ]
    },
    {
      type: 'Advisor',
      entities: [
        {
          name: 'Wirehouse',
          value: 'AdvisorWirehouse'
        },
        {
          name: 'RIA',
          value: 'AdvisorRIA'
        },
        {
          name: 'IBD',
          value: 'AdvisorIBD'
        },
      ]
    },
    {
      type: 'Retirement Plan Advisor',
      entities: [
        {
          name: 'Wirehouse',
          value: 'RetirementPlanAdvisorWirehouse'
        },
        {
          name: 'RIA',
          value: 'RetirementPlanAdvisorRIA'
        },
        {
          name: 'IBD',
          value: 'RetirementPlanAdvisorIBD'
        },
      ]
    },
    {
      type: 'Institutional',
      entities: [
        {
          name: 'Bank',
          value: 'InstitutionalBank'
        },
        {
          name: 'Corporate',
          value: 'InstitutionalCorporate'
        },
        {
          name: 'Credit Union',
          value: 'InstitutionalCreditUnion'
        },
        {
          name: 'Endowment Fund',
          value: 'InstitutionalEndowmentFund'
        },
        {
          name: 'ETF Issuer',
          value: 'InstitutionalETFIssuer'
        },
        {
          name: 'Family Office',
          value: 'InstitutionalFamilyOffice'
        },
        {
          name: 'Hedge Fund',
          value: 'InstitutionalHedgeFund'
        },
        {
          name: 'Hospital',
          value: 'InstitutionalHospital'
        },
        {
          name: 'Mutual Fund Company',
          value: 'InstitutionalMutualFundCompany'
        },
        {
          name: 'Non-profit',
          value: 'InstitutionalNonProfit'
        },
        {
          name: 'Pension Fund',
          value: 'InstitutionalPensionFund'
        },
        {
          name: 'Private Equity',
          value: 'InstitutionalPrivateEquity'
        },
        {
          name: 'Public entity (e.g. Government)',
          value: 'InstitutionalPublicEntity'
        },
        {
          name: 'Real Estate',
          value: 'InstitutionalRealEstate'
        },
        {
          name: 'School',
          value: 'InstitutionalSchool'
        },
        {
          name: 'Securities brokerage',
          value: 'InstitutionalSecuritiesBrokerage'
        },
        {
          name: 'Sovereign Wealth Fund',
          value: 'InstitutionalSovereignWealthFund'
        },
        {
          name: 'Trust',
          value: 'InstitutionalTrust'
        },
        {
          name: 'Venture Capital',
          value: 'InstitutionalVentureCapital'
        },
      ]
    },
    {
      type: 'Insurance Agent',
      entities: [
        {
          name: 'Independent',
          value: 'InsuranceAgentIndependent'
        },
        {
          name: 'RIA affiliated',
          value: 'InsuranceAgentRIA'
        },
        {
          name: 'Captive',
          value: 'InsuranceAgentCaptive'
        },
      ]
    },
  ]

  static Countries = [
    {
      entities: [
        {
          name: 'United States',
          value: 'US'
        },
        {
          name: 'Canada',
          value: 'CA'
        },
        {
          name: 'Afghanistan',
          value: 'AF'
        },
        {
          name: 'Albania',
          value: 'AL'
        },
        {
          name: 'Algeria',
          value: 'DZ'
        },
        {
          name: 'American Samoa',
          value: 'AS'
        },
        {
          name: 'Andorra',
          value: 'AD'
        },
        {
          name: 'Angola',
          value: 'AO'
        },
        {
          name: 'Anguilla',
          value: 'AI'
        },
        {
          name: 'Antarctica',
          value: 'AQ'
        },
        {
          name: 'Antigua and Barbuda',
          value: 'AG'
        },
        {
          name: 'Argentina',
          value: 'AR'
        },
        {
          name: 'Armenia',
          value: 'AM'
        },
        {
          name: 'Aruba',
          value: 'AW'
        },
        {
          name: 'Australia',
          value: 'AU'
        },
        {
          name: 'Austria',
          value: 'AT'
        },
        {
          name: 'Azerbaijan',
          value: 'AZ'
        },
        {
          name: 'Bahamas',
          value: 'BS'
        },
        {
          name: 'Bahrain',
          value: 'BH'
        },
        {
          name: 'Bangladesh',
          value: 'BD'
        },
        {
          name: 'Barbados',
          value: 'BB'
        },
        {
          name: 'Belarus',
          value: 'BY'
        },
        {
          name: 'Belgium',
          value: 'BE'
        },
        {
          name: 'Belize',
          value: 'BZ'
        },
        {
          name: 'Benin',
          value: 'BJ'
        },
        {
          name: 'Bermuda',
          value: 'BM'
        },
        {
          name: 'Bhutan',
          value: 'BT'
        },
        {
          name: 'Bolivia',
          value: 'BO'
        },
        {
          name: 'Bosnia and Herzegovina',
          value: 'BA'
        },
        {
          name: 'Botswana',
          value: 'BW'
        },
        {
          name: 'Bouvet Island',
          value: 'BV'
        },
        {
          name: 'Brazil',
          value: 'BR'
        },
        {
          name: 'British Indian Ocean Territory',
          value: 'IO'
        },
        {
          name: 'Brunei',
          value: 'BN'
        },
        {
          name: 'Bulgaria',
          value: 'BG'
        },
        {
          name: 'Burkina Faso',
          value: 'BF'
        },
        {
          name: 'Burundi',
          value: 'BI'
        },
        {
          name: 'Cambodia',
          value: 'KH'
        },
        {
          name: 'Cameroon',
          value: 'CM'
        },
        {
          name: 'Cape Verde',
          value: 'CV'
        },
        {
          name: 'Cayman Islands',
          value: 'KY'
        },
        {
          name: 'Central African Republic',
          value: 'CF'
        },
        {
          name: 'Chad',
          value: 'TD'
        },
        {
          name: 'Chile',
          value: 'CL'
        },
        {
          name: 'China',
          value: 'CN'
        },
        {
          name: 'Christmas Island',
          value: 'CX'
        },
        {
          name: 'Cocos (Keeling) Islands',
          value: 'CC'
        },
        {
          name: 'Colombia',
          value: 'CO'
        },
        {
          name: 'Comoros',
          value: 'KM'
        },
        {
          name: 'Congo',
          value: 'CG'
        },
        {
          name: 'Congo (DRC)',
          value: 'CD'
        },
        {
          name: 'Cook Islands',
          value: 'CK'
        },
        {
          name: 'Costa Rica',
          value: 'CR'
        },
        {
          name: "Cote d'Ivoire",
          value: 'CI'
        },
        {
          name: 'Croatia (Hrvatska)',
          value: 'HR'
        },
        {
          name: 'Cuba',
          value: 'CU'
        },
        {
          name: 'Cyprus',
          value: 'CY'
        },
        {
          name: 'Czech Republic',
          value: 'CZ'
        },
        {
          name: 'Denmark',
          value: 'DK'
        },
        {
          name: 'Djibouti',
          value: 'DJ'
        },
        {
          name: 'Dominica',
          value: 'DM'
        },
        {
          name: 'Dominican Republic',
          value: 'DO'
        },
        {
          name: 'East Timor',
          value: 'TP'
        },
        {
          name: 'Ecuador',
          value: 'EC'
        },
        {
          name: 'Egypt',
          value: 'EG'
        },
        {
          name: 'El Salvador',
          value: 'SV'
        },
        {
          name: 'Equatorial Guinea',
          value: 'GQ'
        },
        {
          name: 'Eritrea',
          value: 'ER'
        },
        {
          name: 'Estonia',
          value: 'EE'
        },
        {
          name: 'Ethiopia',
          value: 'ET'
        },
        {
          name: 'Falkland Islands (Islas Malvinas)',
          value: 'FK'
        },
        {
          name: 'Faroe Islands',
          value: 'FO'
        },
        {
          name: 'Fiji Islands',
          value: 'FJ'
        },
        {
          name: 'Finland',
          value: 'FI'
        },
        {
          name: 'France',
          value: 'FR'
        },
        {
          name: 'French Guiana',
          value: 'GF'
        },
        {
          name: 'French Polynesia',
          value: 'PF'
        },
        {
          name: 'French Southern and Antarctic Lands',
          value: 'TF'
        },
        {
          name: 'Gabon',
          value: 'GA'
        },
        {
          name: 'Gambia',
          value: 'GM'
        },
        {
          name: 'Georgia',
          value: 'GE'
        },
        {
          name: 'Germany',
          value: 'DE'
        },
        {
          name: 'Ghana',
          value: 'GH'
        },
        {
          name: 'Gibraltar',
          value: 'GI'
        },
        {
          name: 'Greece',
          value: 'GR'
        },
        {
          name: 'Greenland',
          value: 'GL'
        },
        {
          name: 'Grenada',
          value: 'GD'
        },
        {
          name: 'Guadeloupe',
          value: 'GP'
        },
        {
          name: 'Guam',
          value: 'GU'
        },
        {
          name: 'Guatemala',
          value: 'GT'
        },
        {
          name: 'Guinea',
          value: 'GN'
        },
        {
          name: 'Guinea-Bissau',
          value: 'GW'
        },
        {
          name: 'Guyana',
          value: 'GY'
        },
        {
          name: 'Haiti',
          value: 'HT'
        },
        {
          name: 'Heard Island and McDonald Islands',
          value: 'HM'
        },
        {
          name: 'Honduras',
          value: 'HN'
        },
        {
          name: 'Hong Kong SAR',
          value: 'HK'
        },
        {
          name: 'Hungary',
          value: 'HU'
        },
        {
          name: 'Iceland',
          value: 'IS'
        },
        {
          name: 'India',
          value: 'IN'
        },
        {
          name: 'Indonesia',
          value: 'ID'
        },
        {
          name: 'Iran',
          value: 'IR'
        },
        {
          name: 'Iraq',
          value: 'IQ'
        },
        {
          name: 'Ireland',
          value: 'IE'
        },
        {
          name: 'Israel',
          value: 'IL'
        },
        {
          name: 'Italy',
          value: 'IT'
        },
        {
          name: 'Jamaica',
          value: 'JM'
        },
        {
          name: 'Japan',
          value: 'JP'
        },
        {
          name: 'Jordan',
          value: 'JO'
        },
        {
          name: 'Kazakhstan',
          value: 'KZ'
        },
        {
          name: 'Kenya',
          value: 'KE'
        },
        {
          name: 'Kiribati',
          value: 'KI'
        },
        {
          name: 'Korea',
          value: 'KR'
        },
        {
          name: 'Kuwait',
          value: 'KW'
        },
        {
          name: 'Kyrgyzstan',
          value: 'KG'
        },
        {
          name: 'Laos',
          value: 'LA'
        },
        {
          name: 'Latvia',
          value: 'LV'
        },
        {
          name: 'Lebanon',
          value: 'LB'
        },
        {
          name: 'Lesotho',
          value: 'LS'
        },
        {
          name: 'Liberia',
          value: 'LR'
        },
        {
          name: 'Libya',
          value: 'LY'
        },
        {
          name: 'Liechtenstein',
          value: 'LI'
        },
        {
          name: 'Lithuania',
          value: 'LT'
        },
        {
          name: 'Luxembourg',
          value: 'LU'
        },
        {
          name: 'Macao SAR',
          value: 'MO'
        },
        {
          name: 'Macedonia',
          value: 'MK'
        },
        {
          name: 'Madagascar',
          value: 'MG'
        },
        {
          name: 'Malawi',
          value: 'MW'
        },
        {
          name: 'Malaysia',
          value: 'MY'
        },
        {
          name: 'Maldives',
          value: 'MV'
        },
        {
          name: 'Mali',
          value: 'ML'
        },
        {
          name: 'Malta',
          value: 'MT'
        },
        {
          name: 'Marshall Islands',
          value: 'MH'
        },
        {
          name: 'Martinique',
          value: 'MQ'
        },
        {
          name: 'Mauritania',
          value: 'MR'
        },
        {
          name: 'Mauritius',
          value: 'MU'
        },
        {
          name: 'Mayotte',
          value: 'YT'
        },
        {
          name: 'Mexico',
          value: 'MX'
        },
        {
          name: 'Micronesia',
          value: 'FM'
        },
        {
          name: 'Moldova',
          value: 'MD'
        },
        {
          name: 'Monaco',
          value: 'MC'
        },
        {
          name: 'Mongolia',
          value: 'MN'
        },
        {
          name: 'Montserrat',
          value: 'MS'
        },
        {
          name: 'Morocco',
          value: 'MA'
        },
        {
          name: 'Mozambique',
          value: 'MZ'
        },
        {
          name: 'Myanmar',
          value: 'MM'
        },
        {
          name: 'Namibia',
          value: 'NA'
        },
        {
          name: 'Nauru',
          value: 'NR'
        },
        {
          name: 'Nepal',
          value: 'NP'
        },
        {
          name: 'Netherlands',
          value: 'NL'
        },
        {
          name: 'Netherlands Antilles',
          value: 'AN'
        },
        {
          name: 'New Caledonia',
          value: 'NC'
        },
        {
          name: 'New Zealand',
          value: 'NZ'
        },
        {
          name: 'Nicaragua',
          value: 'NI'
        },
        {
          name: 'Niger',
          value: 'NE'
        },
        {
          name: 'Nigeria',
          value: 'NG'
        },
        {
          name: 'Niue',
          value: 'NU'
        },
        {
          name: 'Norfolk Island',
          value: 'NF'
        },
        {
          name: 'North Korea',
          value: 'KP'
        },
        {
          name: 'Northern Mariana Islands',
          value: 'MP'
        },
        {
          name: 'Norway',
          value: 'NO'
        },
        {
          name: 'Oman',
          value: 'OM'
        },
        {
          name: 'Pakistan',
          value: 'PK'
        },
        {
          name: 'Palau',
          value: 'PW'
        },
        {
          name: 'Panama',
          value: 'PA'
        },
        {
          name: 'Papua New Guinea',
          value: 'PG'
        },
        {
          name: 'Paraguay',
          value: 'PY'
        },
        {
          name: 'Peru',
          value: 'PE'
        },
        {
          name: 'Philippines',
          value: 'PH'
        },
        {
          name: 'Pitcairn Islands',
          value: 'PN'
        },
        {
          name: 'Poland',
          value: 'PL'
        },
        {
          name: 'Portugal',
          value: 'PT'
        },
        {
          name: 'Puerto Rico',
          value: 'PR'
        },
        {
          name: 'Qatar',
          value: 'QA'
        },
        {
          name: 'Reunion',
          value: 'RE'
        },
        {
          name: 'Romania',
          value: 'RO'
        },
        {
          name: 'Russia',
          value: 'RU'
        },
        {
          name: 'Rwanda',
          value: 'RW'
        },
        {
          name: 'Samoa',
          value: 'WS'
        },
        {
          name: 'San Marino',
          value: 'SM'
        },
        {
          name: 'Sao Tome and Principe',
          value: 'ST'
        },
        {
          name: 'Saudi Arabia',
          value: 'SA'
        },
        {
          name: 'Senegal',
          value: 'SN'
        },
        {
          name: 'Serbia and Montenegro',
          value: 'YU'
        },
        {
          name: 'Seychelles',
          value: 'SC'
        },
        {
          name: 'Sierra Leone',
          value: 'SL'
        },
        {
          name: 'Singapore',
          value: 'SG'
        },
        {
          name: 'Slovakia',
          value: 'SK'
        },
        {
          name: 'Slovenia',
          value: 'SI'
        },
        {
          name: 'Solomon Islands',
          value: 'SB'
        },
        {
          name: 'Somalia',
          value: 'SO'
        },
        {
          name: 'South Africa',
          value: 'ZA'
        },
        {
          name: 'South Georgia and the South Sandwich Islands',
          value: 'GS'
        },
        {
          name: 'Spain',
          value: 'ES'
        },
        {
          name: 'Sri Lanka',
          value: 'LK'
        },
        {
          name: 'St. Helena',
          value: 'SH'
        },
        {
          name: 'St. Kitts and Nevis',
          value: 'KN'
        },
        {
          name: 'St. Lucia',
          value: 'LC'
        },
        {
          name: 'St. Pierre and Miquelon',
          value: 'PM'
        },
        {
          name: 'St. Vincent and the Grenadines',
          value: 'VC'
        },
        {
          name: 'Sudan',
          value: 'SD'
        },
        {
          name: 'Suriname',
          value: 'SR'
        },
        {
          name: 'Svalbard and Jan Mayen',
          value: 'SJ'
        },
        {
          name: 'Swaziland',
          value: 'SZ'
        },
        {
          name: 'Sweden',
          value: 'SE'
        },
        {
          name: 'Switzerland',
          value: 'CH'
        },
        {
          name: 'Syria',
          value: 'SY'
        },
        {
          name: 'Taiwan',
          value: 'TW'
        },
        {
          name: 'Tajikistan',
          value: 'TJ'
        },
        {
          name: 'Tanzania',
          value: 'TZ'
        },
        {
          name: 'Thailand',
          value: 'TH'
        },
        {
          name: 'Togo',
          value: 'TG'
        },
        {
          name: 'Tokelau',
          value: 'TK'
        },
        {
          name: 'Tonga',
          value: 'TO'
        },
        {
          name: 'Trinidad and Tobago',
          value: 'TT'
        },
        {
          name: 'Tunisia',
          value: 'TN'
        },
        {
          name: 'Turkey',
          value: 'TR'
        },
        {
          name: 'Turkmenistan',
          value: 'TM'
        },
        {
          name: 'Turks and Caicos Islands',
          value: 'TC'
        },
        {
          name: 'Tuvalu',
          value: 'TV'
        },
        {
          name: 'Uganda',
          value: 'UG'
        },
        {
          name: 'Ukraine',
          value: 'UA'
        },
        {
          name: 'United Arab Emirates',
          value: 'AE'
        },
        {
          name: 'United Kingdom',
          value: 'GB'
        },
        {
          name: 'United States Minor Outlying Islands',
          value: 'UM'
        },
        {
          name: 'Uruguay',
          value: 'UY'
        },
        {
          name: 'Uzbekistan',
          value: 'UZ'
        },
        {
          name: 'Vanuatu',
          value: 'VU'
        },
        {
          name: 'Vatican City',
          value: 'VA'
        },
        {
          name: 'Venezuela',
          value: 'VE'
        },
        {
          name: 'Viet Nam',
          value: 'VN'
        },
        {
          name: 'Virgin Islands',
          value: 'VI'
        },
        {
          name: 'Virgin Islands (British)',
          value: 'VG'
        },
        {
          name: 'Wallis and Futuna',
          value: 'WF'
        },
        {
          name: 'Yemen',
          value: 'YE'
        },
        {
          name: 'Zambia',
          value: 'ZM'
        },
        {
          name: 'Zimbabwe',
          value: 'ZW'
        }
      ]
    }
  ]

  static couponThemes = {
    default: {
      borderColor: {
        style: '#ffba46'
      },
      textColor: 'black',
      background: {
        style: 'linear-gradient(to right, #fffcf6, #fff3e0)'
      },
      highlightColor: {
        style: '#ffd985'
      },
      illustration: {
        src: ''
      }
    },
    valentines: {
      borderColor: {
        style: '#ffb0c3'
      },
      textColor: '#E74141',
      background: {
        style: 'linear-gradient(to right, rgba(255, 151, 144, 0.1), rgba(255, 163, 179, 0.5))'
      },
      highlightColor: {
        style: '#ff8080'
      },
      illustration: {
        src: Valentines
      },
      illustrationLeft: {
        src: VLeft
      },
      illustrationRight: {
        src: VRight
      },
      regex: /^LOVE20\d\d$/,
    },
    martinLutherKing: {
      borderColor: {
        style: '#000'
      },
      textColor: '#000',
      background: {
        style: 'linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,0.1))'
      },
      highlightColor: {
        style: 'rgba(97, 114, 135, 0.2)'
      },
      illustration: {
        src: MLK
      },
      illustrationLeft: {
        src: MLKLeft
      },
      illustrationRight: {
        src: MLKRight
      },
      regex: /^KING20\d\d$/,
    },
    memorial: {
      borderColor: {
        style: '#21316d'
      },
      textColor: '#21316D',
      background: {
        style: 'linear-gradient(to left, rgba(54, 68, 120, 0.1), rgba(42, 56, 109, 0))'
      },
      highlightColor: {
        style: 'rgba(33, 49, 109, 0.2)'
      },
      illustration: {
        src: Memorial
      },
      illustrationLeft: {
        src: MLeft
      },
      illustrationRight: {
        src: MRight
      },
      regex: /^MEM20\d\d$/,
    },
    independence: {
      borderColor: {
        style: '#2146ce'
      },
      textColor: '#2146CE',
      background: {
        style: 'linear-gradient(to left, rgba(33, 70, 206, 0.1), rgba(33, 70, 206, 0))'
      },
      highlightColor: {
        style: 'rgba(0, 175, 242, 0.2)'
      },
      illustration: {
        src: Independence
      },
      illustrationLeft: {
        src: ILeft
      },
      illustrationRight: {
        src: IRight
      },
      regex: /^JULY420\d\d$/,
    },
    president: {
      borderColor: {
        style: '#21316d'
      },
      textColor: '#002868',
      background: {
        style: 'linear-gradient(to left, rgba(54, 68, 120, 0.1), rgba(42, 56, 109, 0))'
      },
      highlightColor: {
        style: 'rgba(33, 49, 109, 0.2)'
      },
      illustration: {
        src: President
      },
      illustrationLeft: {
        src: PLeft
      },
      illustrationRight: {
        src: PRight
      },
      regex: /^PREZ20\d\d$/,
    },
    thanksgiving: {
      borderColor: {
        style: '#ff6000'
      },
      textColor: '#ff6000',
      background: {
        style: 'linear-gradient(to left, rgba(255, 181, 0, 0.2), rgba(255, 143, 0, 0))'
      },
      highlightColor: {
        style: 'rgba(255, 143, 0, 0.2)'
      },
      illustration: {
        src: ThanksGiving
      },
      illustrationLeft: {
        src: TLeft
      },
      illustrationRight: {
        src: TRight
      },
      regex: /^THANKSGIVING20\d\d$/,
    },
    halloween: {
      borderColor: {
        style: '#000'
      },
      textColor: '#000',
      background: {
        style: 'linear-gradient(to right, rgba(252, 170, 94, 0.05), rgba(255, 95, 4, 0.15))'
      },
      highlightColor: {
        style: 'rgba(255, 160, 0, 0.2)'
      },
      illustration: {
        src: Halloween
      },
      illustrationLeft: {
        src: HLeft
      },
      illustrationRight: {
        src: HRight
      },
      regex: /^HALLOWEEN20\d\d$/,
    },
    easter: {
      borderColor: {
        style: '#ffba46'
      },
      textColor: '#00A7A1',
      background: {
        style: 'linear-gradient(to left, rgba(255, 181, 0, 0.2), rgba(255, 143, 0, 0))'
      },
      highlightColor: {
        style: 'rgba(255, 186, 70, 0.2)'
      },
      illustration: {
        src: Easter
      },
      illustrationLeft: {
        src: ELeft
      },
      illustrationRight: {
        src: ERight
      },
      regex: /^EASTER20\d\d$/,
    },
    christmas: {
      borderColor: {
        style: '#48997d'
      },
      textColor: '#2E8B6A',
      background: {
        style: 'linear-gradient(to left, rgba(46, 139, 106, 0.1), rgba(46, 139, 106, 0))'
      },
      highlightColor: {
        style: 'rgba(46, 139, 106, 0.2)'
      },
      illustration: {
        src: Christmas
      },
      illustrationLeft: {
        src: CLeft
      },
      illustrationRight: {
        src: CRight
      },
      regex: /^CHRISTMAS20\d\d$/,
    },
    labor: {
      borderColor: {
        style: '#ffba46'
      },
      textColor: '#2146CE',
      background: {
        style: 'linear-gradient(to left, rgba(255, 181, 0, 0.2), rgba(255, 143, 0, 0))'
      },
      highlightColor: {
        style: 'rgba(255, 186, 70, 0.2)'
      },
      illustration: {
        src: Labor
      },
      illustrationLeft: {
        src: LLeft
      },
      illustrationRight: {
        src: LRight
      },
      regex: /^LABOR20\d\d$/,
    },
  }

  static Quotes = [
    {
      text: 'Successful investing is anticipating the anticipations of others.',
      authorTitle: 'British Economist',
      author: 'John Maynard Keynes',
      authorImage: JohnKeynes,
    },
    {
      text: 'Be fearful when others are greedy and greedy when others are fearful.',
      authorTitle: 'Oracle of Omaha, CEO and Chairman of Birkshire Hathaway',
      author: 'Warren Buffett',
      authorImage: WarrenBuffet
    },
    {
      text: 'Time is your friend; impulse is your enemy.',
      authorTitle: 'Founder of The Vanguard Group',
      author: 'John Bogle',
      authorImage: JohnBogle
    },
  ]
}

export default Constants;
